var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.enableEditItem
      ? _c("div", { staticClass: "w-full" }, [
          _c("div", { staticClass: "form-group" }, [
            _c(
              "div",
              { staticClass: "mb-1" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("product.type"),
                      "label-for": "type",
                    },
                  },
                  [
                    _c("b-form-radio-group", {
                      staticClass: "required mr-2",
                      attrs: {
                        id: "type",
                        name: "type",
                        options: _vm.productTypeList,
                      },
                      on: { change: _vm.onChangeProductType },
                      model: {
                        value: _vm.model.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "type", $$v)
                        },
                        expression: "model.type",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
    _vm.enableEditItem && _vm.model.type
      ? _c(
          "div",
          { staticClass: "w-full gap-2 justify-center pt-2" },
          [
            _c(
              "vs-divider",
              { staticClass: "mt-2", attrs: { position: "left" } },
              [_vm._v(_vm._s(_vm.$t("product.available_items")))]
            ),
            _c(
              "vs-table",
              {
                key: "available-" + _vm.model.type,
                attrs: {
                  "no-data": " ",
                  data: _vm.availableItems,
                  "no-data-text": _vm.$t("product.no_available_items"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var data = ref.data
                        return _vm._l(data, function (tr, i) {
                          return _c(
                            "vs-tr",
                            { key: "a-" + i },
                            [
                              _c("vs-td", { attrs: { data: data[i].id } }, [
                                _c("label", [_vm._v(_vm._s(data[i].id))]),
                              ]),
                              _c("vs-td", { attrs: { data: data[i].name } }, [
                                _c("label", [_vm._v(_vm._s(data[i].name))]),
                              ]),
                              _c("vs-td", { attrs: { data: data[i].detail } }, [
                                _c("label", [_vm._v(_vm._s(data[i].detail))]),
                              ]),
                              _c(
                                "vs-td",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "permission",
                                          rawName: "v-permission",
                                          value: "products.items.create",
                                          expression: "'products.items.create'",
                                        },
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: {
                                            content: _vm.$t("adicionar"),
                                            delay: { show: 500, hide: 100 },
                                          },
                                          expression:
                                            "{\n                content: $t('adicionar'),\n                delay: { show: 500, hide: 100 }\n              }",
                                        },
                                      ],
                                      attrs: { variant: "primary", size: "sm" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addItem(data[i])
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        attrs: { icon: "PlusIcon" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  4080381369
                ),
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", { attrs: { width: "5%" } }, [
                      _vm._v(_vm._s(_vm.$t("ID"))),
                    ]),
                    _c("vs-th", { attrs: { width: "50%" } }, [
                      _vm._v(_vm._s(_vm.$t("name"))),
                    ]),
                    _c("vs-th", { attrs: { width: "35%" } }, [
                      _vm._v(_vm._s(_vm.$t("product.detail"))),
                    ]),
                    _c("vs-th", { attrs: { width: "10%" } }, [
                      _vm._v(_vm._s(_vm.$t("actions"))),
                    ]),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "w-full gap-2 justify-center pt-2" },
      [
        _c("vs-divider", { staticClass: "mt-4", attrs: { position: "left" } }, [
          _vm._v(" " + _vm._s(_vm.$t("product.composition"))),
        ]),
        _c(
          "vs-table",
          {
            key: _vm.id,
            attrs: {
              "no-data": " ",
              data: _vm.productItems,
              "no-data-text": _vm.$t("msg_none"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var data = ref.data
                  return _vm._l(data, function (tr, i) {
                    return _c(
                      "vs-tr",
                      { key: i },
                      [
                        _c("vs-td", { attrs: { data: data[i].id } }, [
                          _c("label", [_vm._v(_vm._s(data[i].id))]),
                        ]),
                        _c("vs-td", { attrs: { data: data[i].type_str } }, [
                          _c("label", [_vm._v(_vm._s(data[i].type_str))]),
                        ]),
                        _c("vs-td", { attrs: { data: data[i].name } }, [
                          _c("label", [_vm._v(_vm._s(data[i].name))]),
                        ]),
                        _c(
                          "vs-td",
                          [
                            _vm.enableEditItem
                              ? _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: "products.items.delete",
                                      expression: "'products.items.delete'",
                                    },
                                  ],
                                  staticClass:
                                    "h-5 w-5 mb-1 mr-1 stroke-current text-danger cursor-pointer",
                                  attrs: { icon: "Trash2Icon" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmDeleteItem(data[i])
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  })
                },
              },
            ]),
          },
          [
            _c(
              "template",
              { slot: "thead" },
              [
                _c("vs-th", { attrs: { width: "5%" } }, [
                  _vm._v(_vm._s(_vm.$t("ID"))),
                ]),
                _c("vs-th", { attrs: { width: "25%" } }, [
                  _vm._v(_vm._s(_vm.$t("product.type"))),
                ]),
                _c("vs-th", { attrs: { width: "50%" } }, [
                  _vm._v(_vm._s(_vm.$t("name"))),
                ]),
                _c("vs-th", { attrs: { width: "5%" } }, [
                  _vm._v(_vm._s(_vm.$t("actions"))),
                ]),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }